import { api } from "@services/api";

export async function uploadCsv(data: string[][]) {
    return api.post(`/ravim/arquivo-colab`, data);
  }